// extracted by mini-css-extract-plugin
export var searchCriteria = "search-criteria_Fom3iGEtI3wiwrhGPlPw";
export var searchCriteriaCriteriaContainer = "search-criteria__criteria-container_XvoxmUj3VUhI70RhawaM";
export var searchCriteriaHeader = "search-criteria__header_LgU5IqzSx53ahVL7tUvu";
export var searchCriteriaMyAccountInfoContainer = "search-criteria__my-account-info-container_gRWgxvTLcotlKOY5Txaw";
export var searchCriteriaStripContainer = "search-criteria__strip-container_bGgHq3jmCdTkwd1dnYam";
export var searchCriteriaTrashButton = "search-criteria__trash-button_EVAb3FPjwIxJnSICP4n8";